
export default {
  props: { blog: { type: Object, required: true } },
};
